import React, { useCallback, useContext, useEffect, useState } from "react";
import AuthContext from "../../contexts/AuthContext";
import SelectedTeamContext from "../../contexts/SelectedTeamContext";
import WBCYearsContext from "../../contexts/WBCYearsContext";
import { QUALIFYING } from "../../constants/TournamentTypeConstants";
import CoachingStaffSection from "./CoachingStaffSection";
import { withRouter } from "react-router-dom";
import WBCCollapse from "../elements/WBCCollapse";
import CreateProfileForm from "../profile/create-form/CreateProfileForm";
import CoachingStaffContext from "../../contexts/CoachingStaffContext";
import WBCAdminAccess from "../protected/WBCAdminAccess";
import CoachingStaffConstants from "../../constants/CoachingStaffConstants";
import StaffApi from "../../httpClients/StaffApi";
import TournamentFormContext from "../../contexts/TournamentFormContext";
import RosterApi from "../../httpClients/RosterApi";
import useTournamentType from "../hooks/useTournamentType";
import styled from "styled-components";

const Content = styled.div.attrs(() => ({
  className: "p-4"
}))`
  text-align: left;
  height: 74vh;
  overflow: scroll;
`;

const CoachingStaff = withRouter(({ history }) => {
  const { isWBCI } = useContext(AuthContext).state;
  const { teamId: fedTeamId } = useContext(SelectedTeamContext).state.team;
  const { selectedWbcYear } = useContext(WBCYearsContext);
  const coachingStaffContext = useContext(CoachingStaffContext);

  const { dispatch: coachingStaffContextDispatch } = coachingStaffContext;
  const { shouldLoadStaff, staff } = coachingStaffContext.state;

  const tournamentFormContext = useContext(TournamentFormContext);
  const { dispatch: tournamentDispatch } = tournamentFormContext;

  const { tournamentType } = useTournamentType();
  const [tournamentSettings, setTournamentSettings] = useState(null);

  const [uniformUpdates, setUniformUpdates] = useState([]);

  const loadStaff = useCallback(
    tourneyType => {
      if (!fedTeamId || !tourneyType) {
        return;
      }

      coachingStaffContextDispatch({ type: "reset" });
      StaffApi.getTeamStaff(fedTeamId, tourneyType).then(response => {
        coachingStaffContextDispatch({ type: "setStaff", staff: response });
      });
      coachingStaffContextDispatch({ type: "setShouldLoadStaff", shouldLoadStaff: false });
    },
    [coachingStaffContextDispatch, fedTeamId]
  );

  useEffect(() => {
    if (fedTeamId && tournamentType) {
      coachingStaffContextDispatch({ type: "setShouldLoadStaff", shouldLoadStaff: true });
    }
  }, [coachingStaffContextDispatch, fedTeamId, tournamentType]);

  useEffect(() => {
    if (shouldLoadStaff) {
      loadStaff(tournamentType);
    }
  }, [shouldLoadStaff, loadStaff, tournamentType]);

  useEffect(() => {
    tournamentDispatch({
      type: "setOnSave",
      onSave: () => {
        RosterApi.updateUniforms(fedTeamId, uniformUpdates);
      }
    });
  }, [tournamentDispatch, fedTeamId, uniformUpdates]);

  useEffect(() => {
    tournamentDispatch({
      type: "setOnCancel",
      onCancel: () => {
        setUniformUpdates([]);
        loadStaff(tournamentType);
      }
    });
  }, [tournamentDispatch, tournamentType, loadStaff]);

  useEffect(() => {
    if (selectedWbcYear && tournamentType) {
      const selectedYearTournamentSettings =
        tournamentType === QUALIFYING
          ? selectedWbcYear.qualifyingTournamentSettings
          : selectedWbcYear.mainTournamentSettings;
      setTournamentSettings(selectedYearTournamentSettings);
    }
  }, [selectedWbcYear, tournamentType]);

  return (
    <Content>
      <WBCAdminAccess>
        <WBCCollapse title="Create a new staff member" startsOpen={false}>
          <CreateProfileForm />
        </WBCCollapse>
      </WBCAdminAccess>
      <CoachingStaffSection
        staff={{
          type: CoachingStaffConstants.PERSONNEL_TYPE.COACHES,
          min: tournamentSettings?.coaches?.coachesMin,
          max: tournamentSettings?.coaches?.coachesMax
        }}
        isWBCI={isWBCI}
        personnel={staff?.coaches || []}
        setUniformUpdates={setUniformUpdates}
      />
      <CoachingStaffSection
        staff={{
          type: CoachingStaffConstants.PERSONNEL_TYPE.MANAGERS,
          min: tournamentSettings?.managers?.managersMin,
          max: tournamentSettings?.managers?.managersMax
        }}
        isWBCI={isWBCI}
        personnel={staff?.managers || []}
        setUniformUpdates={setUniformUpdates}
      />
      <CoachingStaffSection
        staff={{
          type: CoachingStaffConstants.PERSONNEL_TYPE.MEDICAL_STAFF,
          min: tournamentSettings?.trainers?.trainersMin,
          max: tournamentSettings?.trainers?.trainersMax
        }}
        isWBCI={isWBCI}
        personnel={staff?.trainers || []}
        setUniformUpdates={setUniformUpdates}
      />
      {/* Hidden as not needed, but did not delete in case a future use case comes up */}
      {/* <CoachingStaffSection
        staff={{
          type: CoachingStaffConstants.PERSONNEL_TYPE.CUSTOM_STAFF
        }}
        isWBCI={isWBCI}
        personnel={staff?.customStaff || []}
        setUniformUpdates={setUniformUpdates}
      /> */}
      <CoachingStaffSection
        staff={{
          type: CoachingStaffConstants.PERSONNEL_TYPE.TEAM_STAFF
        }}
        isWBCI={isWBCI}
        personnel={staff?.teamStaff || []}
        setUniformUpdates={setUniformUpdates}
      />
    </Content>
  );
});

export default CoachingStaff;
